import { useEffect, useState } from 'react';
import api from './api';

export const fallbackPlans = [
  {
    name: 'Start', nameAr: 'البداية', price: '1,000', priceZatca: '1,500', period: 'سنوياً',
    desc: 'مثالية للأنشطة الصغيرة والناشئة', popular: false,
    color: 'from-gray-500 to-gray-600', borderColor: 'border-gray-500/30',
    features: ['المبيعات والفواتير','المشتريات والموردين','إدارة المخزون','سندات القبض والصرف','تقارير مالية أساسية','مستخدم واحد','دعم فني عبر البريد'],
    disabled: ['الموارد البشرية','التصنيع','القطاع الطبي','إيجار المعدات','لوحة تحكم متقدمة']
  },
  {
    name: 'Pro', nameAr: 'المتقدمة', price: '2,000', priceZatca: '2,500', period: 'سنوياً',
    desc: 'للأنشطة المتوسطة والمتنامية', popular: true,
    color: 'from-orvix-primary to-blue-600', borderColor: 'border-orvix-primary/50',
    features: ['جميع مميزات باقة Start','الحسابات العامة المتقدمة','إدارة العملاء والأقساط','التقارير المالية التفصيلية','التقارير الضريبية (VAT)','إدارة الفروع المتعددة','مستخدمين (حتى 5)','دعم فني عبر الهاتف والبريد','تطبيق الجوال','تكامل مع البنوك'],
    disabled: ['الموارد البشرية','التصنيع']
  },
  {
    name: 'Premium', nameAr: 'الشاملة', price: '3,500', priceZatca: '4,000', period: 'سنوياً',
    desc: 'الحل الشامل للشركات الكبيرة', popular: false,
    color: 'from-amber-500 to-orange-500', borderColor: 'border-amber-500/50',
    features: ['جميع مميزات باقة Pro','الموارد البشرية (HR)','إدارة التصنيع والإنتاج','القطاع الطبي والصيدليات','إيجار المعدات والآليات','النشاطات التجارية المتعددة','مستخدمين غير محدود','API مفتوح للتكامل','دعم فني مخصص 24/7','تخصيص كامل للنظام','تدريب على الموقع','استضافة خاصة متاحة'],
    disabled: []
  }
];

const usePricingPlans = () => {
  const [plans, setPlans] = useState(fallbackPlans);

  useEffect(() => {
    api.get('/pricing')
      .then(({ data }) => {
        if (Array.isArray(data) && data.length) setPlans(data);
      })
      .catch(() => {});
  }, []);

  return plans;
};

export default usePricingPlans;
